import { IAppState } from '../../store';

export const selectAnswerFormAnswerId = (state: IAppState) => state.answerForm.answerId;
